import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=5c2300cc&scoped=true"
import script from "./calendar.vue?vue&type=script&lang=js"
export * from "./calendar.vue?vue&type=script&lang=js"
import style0 from "./calendar.vue?vue&type=style&index=0&id=5c2300cc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2300cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c2300cc')) {
      api.createRecord('5c2300cc', component.options)
    } else {
      api.reload('5c2300cc', component.options)
    }
    module.hot.accept("./calendar.vue?vue&type=template&id=5c2300cc&scoped=true", function () {
      api.rerender('5c2300cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/calendar.vue"
export default component.exports